import { Bell } from "lucide-react";
import { Link } from "react-router-dom";
import { apiRequest } from "../lib/api";
import { useAsync } from "../hooks/useAsync";
import { useNotificationRefresh } from "../hooks/useNotificationRefresh";

export function NotificationBell() {
  const result = useAsync((signal) => apiRequest<{ unread: number }>("/agent/notifications/summary", { signal }), []);
  useNotificationRefresh(result.refresh);
  const unread = result.data?.unread || 0;
  return <Link className="icon-button notification-bell" to="/agent/notifications"
    aria-label={result.error ? "Notifications — count unavailable" : `Notifications${unread ? `, ${unread} unread` : ""}`}
    title={result.error ? "Open notifications (count unavailable)" : "Notifications"}>
    <Bell aria-hidden="true" size={20} />
    {unread > 0 && <span className="notification-bell__count" aria-hidden="true">{unread > 99 ? "99+" : unread}</span>}
  </Link>;
}
